import { render } from "./Applications.vue?vue&type=template&id=39c6fda8&ts=true"
import script from "./Applications.vue?vue&type=script&lang=ts"
export * from "./Applications.vue?vue&type=script&lang=ts"

import "./Applications.vue?vue&type=style&index=0&id=39c6fda8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__